export const navItems = [
  {
    icon: '1',
    label: 'Operación y Propiedad'
  },
  {
    icon: '2',
    label: 'Ubicación'
  },
  {
    icon: '3',
    label: 'Características'
  },
  {
    icon: '4',
    label: 'Fotos y Multimedia'
  },
  {
    icon: '5',
    label: 'Extras'
  }
];

export const getPageHeader = (data, create) =>
  create
    ? {
        title: 'Cree una propiedad',
        description:
          'Ingrese los datos de la propiedad que desee cargar. Intente completar todos los campos para que los usuarios puedan encontrarla más fácilmente.'
      }
    : {
        title: 'Modifique la propiedad',
        description: data?.title
      };
